

















































































































































































































import notificationEvent from "@/resources/mixins/notifications/notificationEvent";
import UserValidator from "@/resources/mixins/userValidator";
import moment from "moment";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ClickOutsideDirective } from "../../../../../helpers/directives/clickOutside.directive";

@Component({
  name: "manage-logs-component",
  directives: { ClickOutsideDirective },
})
export default class ManageLogsComponent extends mixins(
  UserValidator,
  notificationEvent
) {
  @Prop({ default: true }) isCampusLogs;
  logs = [];
  currentPage = 1;
  itemsPerPage = 30;
  lastPage = 1;
  searchUserName = "";
  loader = false;
  userLoader = false;
  users = [];
  timeout = undefined;

  showUserLogs = false;
  userLogs = [];
  userLogsCurrentPage = 1;
  userLogsItemsPerPage = 30;
  userLogsLastPage = 1;
  startDate = moment(new Date()).subtract(1, "months").format("yyyy-MM-DD");
  endDate = moment(new Date()).format("yyyy-MM-DD");
  mounted() {
    this.getSuperSpaceLogs();
  }
  momentDate(date: string): string {
    return moment(date).format("MMMM DD YYYY, HH:mm");
  }
  close() {
    this.searchUserName = "";
    this.users = [];
  }
  get superSpace(): any {
    return this.$store.getters["SuperSpaceStore/getSuperSpace"];
  }
  @Watch("currentPage")
  getSuperSpaceLogs() {
    this.loader = true;
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    if (this.isSuperSpaceOwner() && this.isCampusLogs) {
      const selectedSpaceCustomize = space;
      this.$store.dispatch("LogsStore/getLogsWithQueryAction", {
        query: `spaceUser.space.superSpace=${
          selectedSpaceCustomize ? selectedSpaceCustomize.superSpace.id : this.superSpace.id
        }`,
        page: this.currentPage,
        callback: (response) => {
          this.lastPage = parseInt(response.headers["pagination-last-page"]);
          this.itemsPerPage = parseInt(
            response.headers["pagination-items-per-page"]
          );
          this.logs = response.data;
          this.loader = false;
        },
      });
    } else
      this.$store.dispatch("LogsStore/getLogsWithQueryAction", {
        query: `spaceUser.space=${space.id}`,
        page: this.currentPage,
        callback: (response) => {
          this.lastPage = parseInt(response.headers["pagination-last-page"]);
          this.itemsPerPage = parseInt(
            response.headers["pagination-items-per-page"]
          );
          this.logs = response.data;
          this.loader = false;
        },
      });
  }
  @Watch("searchUserName")
  updateoSearch(): void {
    this.users = [];
    if (this.searchUserName === "") return;
    if (this.timeout != undefined) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getUsers();
      this.timeout = undefined;
    }, 1000);
  }
  getUsers(): void {
    this.userLoader = true;
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    const selectedSpaceCustomize = space;
    if (this.isSuperSpaceOwner() && this.isCampusLogs) {
      this.$store.dispatch("SuperSpaceUserStore/getSuperSpaceUsersAction", {
        superSpaceId: selectedSpaceCustomize ? selectedSpaceCustomize.superSpace.id : this.superSpace.id,
        page: 1,
        itemsPerPage: 100,
        search:
          this.searchUserName != ""
            ? "&search=" +
              this.searchUserName
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            : "",
        permissions: "",
        callback: (response) => {
          this.users = response.data;
          this.userLoader = false;
        },
        callbackError: (error) => {
          this.userLoader = false;
          this.onError(
            this.$i18n.t("notifications.titles.error"),
            this.$i18n.t("notifications.genericError.genericErrorRetry"),
            "none"
          );
        },
      });
    } else {
      this.$store.dispatch("SpaceStore/getUsersAction", {
        spaceId: selectedSpaceCustomize.id,
        page: 1,
        itemsPerPage: 100,
        search:
          this.searchUserName != ""
            ? "&search=" +
              this.searchUserName
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            : "",
        permissions: "",
        callback: (response) => {
          this.users = response.data;
          this.userLoader = false;
        },
        callbackError: (error) => {
          this.userLoader = false;
          this.onError(
            this.$i18n.t("notifications.titles.error"),
            this.$i18n.t("notifications.genericError.genericErrorRetry"),
            "none"
          );
        },
      });
    }
  }
  transformToSpaceUser(user) {
    if (user.superSpaceUser) {
      user["user"] = user.superSpaceUser.user;
      return user;
    }
    return user;
  }
  @Watch("userLogsCurrentPage")
  getLogOfUser(id) {
    this.showUserLogs = true;
    if (this.isSuperSpaceOwner() && this.isCampusLogs) {
      this.$store.dispatch("LogsStore/getLogsWithQueryAction", {
        query: `spaceUser.superSpaceUser=${id}`,
        page: this.userLogsCurrentPage,
        callback: (response) => {
          this.userLogsLastPage = parseInt(
            response.headers["pagination-last-page"]
          );
          this.userLogsItemsPerPage = parseInt(
            response.headers["pagination-items-per-page"]
          );
          this.userLogs = response.data;
        },
      });
    } else {
      this.$store.dispatch("LogsStore/getLogsWithQueryAction", {
        query: `spaceUser=${id}`,
        page: this.userLogsCurrentPage,
        callback: (response) => {
          this.userLogsLastPage = parseInt(
            response.headers["pagination-last-page"]
          );
          this.userLogsItemsPerPage = parseInt(
            response.headers["pagination-items-per-page"]
          );
          this.userLogs = response.data;
        },
      });
    }
  }
  downloadCsvAction() {
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    const selectedSpaceCustomize = space;
    this.$store.dispatch("LogsStore/downloadCsvAction", {
      type: this.isCampusLogs ? "super_space" : "space",
      id: this.isCampusLogs ? selectedSpaceCustomize.superSpace.id : selectedSpaceCustomize.id,
      from: moment(this.startDate).format("yyyy-MM-DD") + " 00:00:00",
      to: moment(this.endDate).format("yyyy-MM-DD") + " 23:59:59",
      callback: (response) => {
        // do nothing
      },
    });
  }
}
